import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: "",
  processing: false,
  allPharmacists: [],
  newPharmacist: {},
  filteredPharmacists: [],
  pharmacistFormError:"",
  page: 0,
  hasPrev: false,
  total_pages: 0,
  total_result: 0,
}

const pharmacistSlice = createSlice({
  name: "pharmacistSlice",
  initialState: initialState,
  reducers: {
    fetchPharmacistList: () => {
    },
    createPharmacist: () => {
    },
    filterPharmacists: () => {
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setProcessing: (state) => {
      state.processing = true;
      state.newPharmacist = {}
      state.pharmacistFormError = ""
    },
    setPharmacistList: (state, action) => {
      state.allPharmacists = action.payload.data
      state.total_pages = action.payload.total_pages
      state.total_result = action.payload.total_result
      state.loading = false;
    },
    setFilteredPharmacists: (state, action) => {
      state.filteredPharmacists = action.payload
    },
    setNewPharmacist: (state, action) => {
      state.allPharmacists.push(action.payload)
      state.newPharmacist = action.payload
      state.processing = false;
    },
    setPharmacistFormError:(state, action) => {
      state.processing = false;
      state.pharmacistFormError = action.payload
    }
  },
});

export const {
  setLoading,
  setError,
  setProcessing,
  setPharmacistList,
  setFilteredPharmacists,
  setNewPharmacist,
  fetchPharmacistList,
  createPharmacist,
  filterPharmacists,
  setPharmacistFormError
} = pharmacistSlice.actions;
export default pharmacistSlice.reducer;
